import { QuoteSurchargeType } from "./quote-surcharge-type.model";
import { RateMapper } from "../../rate/rate.mapper";
import { SurchargeTypeMapper } from "../../surcharge-type/surcharge-type.mapper";

export class QuoteSurchargeTypeMapper {
  public static map(data: any): QuoteSurchargeType {
    return new QuoteSurchargeType(
      data.id,
      RateMapper.map(data.rate),
      SurchargeTypeMapper.map(data.surchargeType),
      data.surchargeTypeId ?? null,
    );
  }
}
